export default __webpack_public_path__ + "static/media/check-icon.b6dfa45b.svg";